import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "react-pdfjs" */ '../components/PDF'));
